import fetchPlus from "../lib/fetchPlus/fetchPlus";

const authService = {
    getFreshUserSession: async () =>
        fetchPlus<{ session: string }>(`${process.env.NEXT_PUBLIC_INTERNAL_API_URL}/auth/get-fresh-session-details`, "GET"),

    logout: async () => fetchPlus(`${process.env.NEXT_PUBLIC_AUTH_API}/auth`, "DELETE", {}, true, false),
};

export default authService;
